import Client from '../AxiosClient';
const resource = '/public/publicbudgetreport';

export default {
    //#region BudgetReport
    async searchPublicReport(reportName, circularsTemplateNo, circularsNo, cateId, reportTypeId, status, periodType, periodValue, reportYear, page, size) {
        try {
            if (cateId === -1)
                cateId = "";
            if (reportTypeId === -1)
                reportTypeId = "";
            if (status === -1)
                status = "";
            if (periodType === -1)
                periodType = "";
            if (periodValue === -1)
                periodValue = "";
            if (page === -1)
                page = 1;
            if (size === -1)
                size = 1000;
            const result = await Client.get(`${resource}/searchpublicreport?report_name=${reportName}&circulars_template_no=${circularsTemplateNo}&circulars_no=${circularsNo}&cate_id=${cateId}&report_type_id=${reportTypeId}&status=${status}&period_type=${periodType}&period_value=${periodValue}&report_year=${reportYear}&page=${page}&size=${size}`);
            return result.data;
        } catch (error) {
            return { error: error };
        }
    },
    async getItemsTree() {
        try {
            const response = await Client.get(`${resource}/items`);
            return response.data.data;
        } catch (error) {
            return {error: error};
        }
    },
}